<template>
  <div class="m-1 p-3 employee-card border">
    <!-- details -->
    <div v-if="!editing" class="employee-card-details">
      <p class="p-0 mr-2 mb-0 font-weight-bold">{{name}}</p>
      <p class="p-0 m-0 font-italic">{{emailData}}</p>
    </div>
    <div v-if="editing" class="employee-card-details">
      <b-form-input v-model="name" placeholder="Name"></b-form-input>
      <b-form-input v-model="emailData" placeholder="Email"></b-form-input>
    </div>
    <!-- options dropdown -->
    <div class="employee-card-options">
      <b-button v-if="!editing" size="sm" variant="outline" @click="editing = true">
        <i class="material-icons">edit</i>
      </b-button>
      <b-button v-if="!editing" size="sm" variant="outline" @click="deleteEmployee">
        <i class="material-icons">delete</i>
      </b-button>
      <b-button
        v-if="editing"
        size="m"
        variant="success"
        @click="editing = false; updateInfo()"
      >Done</b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    email: String
  },
  data() {
    return {
      editing: false,
      emailData: "",
      prevEmail: "",
      name: ""
    };
  },
  mounted() {
    this.$data.name = this.$store.getters["employee"](this.email).name;
    this.$data.emailData = this.$store.getters["employee"](this.email).email;
    this.$data.prevEmail = this.$data.emailData;
  },
  methods: {
    updateInfo() {
      this.$store.dispatch("updateEmployee", {
        prevEmail: this.$data.prevEmail,
        updates: {
          email: this.$data.emailData,
          name: this.$data.name
        }
      });
      this.$data.prevEmail = this.$data.emailData;
    },
    deleteEmployee() {
      this.$store.dispatch("deleteEmployee", {
        email: this.$props.email
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/mixins";
@import "../styles/variables";
.employee-card {
  width: 100%;
  max-width: 45em;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  &-details {
    display: flex;
    flex-flow: row nowrap;
  }
}
</style>


